import { ArrowDownLeft, ArrowUpRight } from 'lucide-react'
import { DirectionPill } from '@/components/DirectionPill'
import type { ClientMessage } from '../types'

export function MessageDirectionBadge({
  direction,
}: {
  direction: ClientMessage['direction']
}) {
  const incoming = direction === 'inbound'
  return (
    <DirectionPill
      direction={direction}
      icon={incoming ? ArrowDownLeft : ArrowUpRight}
      label={incoming ? 'Incoming' : 'Outgoing'}
    />
  )
}
